import { createInstance } from '@datapunt/matomo-tracker-react';

let matomoInitialized = false;

export const isMatomoEnabled = () => matomoInitialized;

export function initMatomo(): any {
	if (process.env.REACT_APP_MATOMO_BASE_URL) {
		matomoInitialized = true;

		return null;
		// createInstance({
		// 	urlBase: process.env.REACT_APP_MATOMO_BASE_URL,
		// 	siteId: 30,
		// });
	}

	return null;
}
